'use strict';

define('components/nav/navigation.favorites',['./navigation', 'features/favorites'], function (Navigation, favorites) {
  var FavoriteOffersPlugin = Navigation.Plugin.extend({
    onRendered: function () {
      var nav = this.getNavigation();
      nav.walk(function (link, path) {
        // Add the span to show favorite count next to the favorites link(s)
        if (link.type === 'link' && link.url.indexOf('/favorites/') > 0 && nav.getPathRegion(path).key === 'utility') {
          var els = nav.getDOMNodes(link);
          $(els).find('a > span').append('<span class="favorite-count"></span>');
        }
      });
      favorites.mainNav();
    },
  });

  Navigation.registerPlugin(FavoriteOffersPlugin);
});

